import { useAppSelector } from '@/redux/hooks'
import { CommunityInsertMember } from './communityInsertMember'
import { BoardHeader } from '../../_components/boardHeader'
import { getHeaderTitle } from '../../boardItem'

const CommunityInsertBoard = () => {
  const headerTitle = getHeaderTitle(window.location.pathname)
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  return (
    <>
      <BoardHeader title={headerTitle} />
      {/* {isAuthenticated ? <CommunityInsertMember /> : <CommunityInsertGuest />} */}
      {isAuthenticated && <CommunityInsertMember />}
    </>
  )
}

export default CommunityInsertBoard
